import React from 'react';
import { Link } from 'react-router-dom';
import * as Icons from 'lucide-react';
import { ArrowRight } from 'lucide-react';
import { services } from '../../mock';

const Services = () => {
  return (
    <section className="py-20 lg:py-28 bg-slate-50">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <span className="font-heading font-semibold text-brand-orange text-sm uppercase tracking-[0.15em]">What we do</span>
          <h2 className="font-heading font-bold text-3xl md:text-4xl text-slate-900 mt-3 mb-4">Care & support, tailored to you</h2>
          <p className="font-body text-slate-600">A broad range of health and social care support, shaped around each person and the people who care about them.</p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s) => {
            const Icon = Icons[s.icon] || Icons.Heart;
            return (
              <Link
                key={s.slug}
                to="/services"
                className="group relative bg-white rounded-2xl p-7 border border-slate-100 hover:border-brand-blue/30 hover:shadow-xl transition-all duration-300 overflow-hidden"
              >
                <span className="absolute top-0 left-0 h-1 w-0 bg-brand-mint group-hover:w-full transition-all duration-500" />
                <div className="w-14 h-14 rounded-2xl bg-brand-blue-light flex items-center justify-center mb-5 group-hover:bg-brand-blue transition-colors duration-300">
                  <Icon className="w-7 h-7 text-brand-blue group-hover:text-white transition-colors duration-300" strokeWidth={1.8} />
                </div>
                <h3 className="font-heading font-semibold text-lg text-slate-900 mb-2 leading-snug">{s.title}</h3>
                <p className="font-body text-sm text-slate-600 leading-relaxed mb-4">{s.desc}</p>
                <span className="inline-flex items-center gap-1.5 text-sm font-semibold text-brand-blue group-hover:gap-3 transition-all duration-300">
                  Learn more <ArrowRight className="w-4 h-4" />
                </span>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
